import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'split'
})

export class SplitPipe implements PipeTransform {

transform(value: string, args: any[]): string[] {
    if(value != null) {
        var array = value.length > 0 ? value.replace(/\s/g, "").split(args[0]) : args;
        //var array = "test";
        //console.log("Array", array);
        return array;
    }
   }
}